import {
    type PaginatedRequestQueryParams,
    type APIWorkOrder,
    type APIWorkOrderListParams,
} from '@visorpro/client'
import { makeAutoObservable, runInAction } from 'mobx'
import _ from 'lodash'
import { visorPRORestClient } from '../util/api'
import { observed } from '../util/observed-decorator'

export class WorkOrdersStore {
    public workOrdersById: Record<string, APIWorkOrder> = {}
    public totalWorkOrders: number = 0
    public isFetching: boolean = false
    public isFetched: boolean = false
    private _pagination: PaginatedRequestQueryParams = {
        limit: 1000,
        offset: 0,
    }

    constructor() {
        makeAutoObservable(this)
    }

    public get workOrders(): APIWorkOrder[] {
        return _.values(this.workOrdersById)
    }

    public get pagination(): PaginatedRequestQueryParams {
        return this._pagination
    }

    @observed('isFetching')
    public async list(queryParams?: APIWorkOrderListParams) {
        runInAction(() => {
            this._pagination = queryParams || this._pagination
        })

        const response = await visorPRORestClient.workOrder.list(queryParams)
        runInAction(() => {
            this.workOrdersById = _.keyBy(response.items, 'id')
            this.totalWorkOrders = response.total
            this.isFetched = true
            this._pagination = queryParams || this._pagination
        })
    }
}
